// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* games/crimescene/CrimeScene.css */

.crimescene-board {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 95%;
  max-width: 400px;
  max-height: 95%;
  background: radial-gradient(circle, #3e3e3e 0%, #1a1a1a 100%);
  border: 8px solid #5d4037;
  box-shadow: inset 0 0 40px rgba(0,0,0,0.8), 0 20px 50px rgba(0,0,0,0.9);
  border-radius: 4px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 6000;
}

/* ЗАГОЛОВОК */
.crimescene-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  background: #fdf6e3;
  padding: 8px 12px;
  border-radius: 2px;
  transform: rotate(-1deg);
  box-shadow: 0 2px 4px rgba(0,0,0,0.3);
  font-family: 'Courier New', monospace;
  color: #2c3e50;
  box-sizing: border-box;
}

.cs-title {
  font-weight: 900;
  font-size: 18px;
  text-transform: uppercase;
  border-bottom: 2px solid #c0392b;
}

.cs-stats { font-size: 14px; font-weight: bold; }
.cs-score { color: #27ae60; margin-left: 5px; }
.cs-penalty { color: #c0392b; margin-left: 5px; }

/* СЕТКА */
.cs-grid {
  display: grid;
  /* Удаляем grid-template-columns: repeat(4, 1fr) */
  /* Удаляем aspect-ratio: 1 / 1 */
  width: 100%;
  max-height: 80vh;
  box-sizing: border-box;
}

/* КАРТОЧКА */
.cs-card-container {
  position: relative;
  width: 100%;
  height: 100%;
  perspective: 1000px;
  cursor: pointer;
}

.cs-card-container.solved {
  /*
     vanish 0.3s -> время самого исчезновения (быстро)
     ease-in
     0.6s -> задержка перед стартом (успеваем посмотреть)
  */
  animation: vanish 0.3s ease-in 0.6s forwards;
  pointer-events: none;
}

@keyframes vanish {
  0% { opacity: 1; transform: scale(1); }
  100% { opacity: 0; transform: scale(0.5); }
}

.cs-card {
  width: 100%;
  height: 100%;
  position: relative;
  /* Оптимальная скорость переворота: не мгновенно, но быстро */
  transition: transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
  transform-style: preserve-3d;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.4);
  will-change: transform; /* Оптимизация рендера */
}

.cs-card.flipped { transform: rotateY(180deg); }
.cs-card.solved-visual { transform: rotateY(180deg); box-shadow: 0 0 15px #27ae60; }

/* ЛИЦО И РУБАШКА */
.cs-card-front, .cs-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  /* ВАЖНО: скрываем заднюю часть, чтобы не было просветов при перевороте */
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.cs-card-front {
  background: repeating-linear-gradient(45deg, #4a657e, #4a657e 10px, #587691 10px, #587691 20px);
  z-index: 2; /* Фронт всегда выше по умолчанию */
}
.cs-card-front::after {
  content: '?';
  font-size: 1.5rem; /* Используем rem для адаптивности */
  color: rgba(255,255,255,0.3);
  font-weight: bold;
}

.cs-card-back {
  transform: rotateY(180deg);
  background: #fff;
  /* Удаляем фиксированный font-size: 42px */
  line-height: 1;
  z-index: 1;
  /* Декор под фотобумагу */
  padding: 2px; /* Уменьшаем паддинг */
  padding-bottom: 6px;
  background-clip: padding-box;
}

/* Декор "Скотч" */
.cs-card-container::before {
  content: '';
  position: absolute;
  top: -6%;
  left: 50%;
  transform: translateX(-50%);

  width: 45%; 
  height: 14%; 

  background: rgba(255, 255, 255, 0.3);
  z-index: 10;


  box-shadow: 0 1px 2px rgba(0,0,0,0.1);

  backdrop-filter: blur(1px);
  pointer-events: none; 
}

/* Более резкая и частая тряска, сохраняющая поворот */
@keyframes shake-flipped {
  0%, 100% { transform: rotateY(180deg) translateX(0); }
  20% { transform: rotateY(180deg) translateX(-8px) rotate(-5deg); }
  40% { transform: rotateY(180deg) translateX(8px) rotate(5deg); }
  60% { transform: rotateY(180deg) translateX(-5px) rotate(-3deg); }
  80% { transform: rotateY(180deg) translateX(5px) rotate(3deg); }
}

.cs-card-container.shake .cs-card {
  /* 0.3s - быстро и резко */
  animation: shake-flipped 0.3s ease-in-out;
  box-shadow: 0 0 15px #c0392b;
}

/* Убедись, что у самого контейнера анимации НЕТ (если осталась с прошлого раза - удали) */
.cs-card-container.shake {
  animation: none;
}

/* ШТРАФ (-1) */
.penalty-floating {
  position: absolute;
  top: 50%; left: 50%; transform: translate(-50%, -50%);
  color: #c0392b; font-size: 40px; font-weight: 900;
  text-shadow: 2px 2px 0 #fff; z-index: 100;
  animation: floatUp 1.2s forwards;
  pointer-events: none;
}
@keyframes floatUp {
  0% { opacity: 1; transform: translate(-50%, -50%) scale(0.5); }
  100% { opacity: 0; transform: translate(-50%, -150%) scale(1.5); }
}

/* ЦЕНТРОВКА РАПОРТА */
.cs-report-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cs-report-wrapper .quiz-container {
  position: relative !important; top: auto !important; left: auto !important;
  transform: rotate(-1deg) !important; width: 90% !important; max-width: 320px !important; margin: 0 !important;
}

/* --- ЭКРАН РЕЗУЛЬТАТОВ: ПОЛИЦЕЙСКОЕ ДОСЬЕ (V2) --- */

.cs-result-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.9); /* Темнее фон вокруг */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 50;
  backdrop-filter: blur(8px);
  animation: fadeIn 0.4s ease-out;
}

.cs-report-card {
  width: 90%;
  max-width: 360px; /* Чуть шире */

  /* ЦВЕТ: Папка "Manila Folder" */
  background-color: #f0e6cf;

  /* ТЕКСТУРА: Убрали сетку, добавили шум и виньетку (затемнение краев) */
  background-image:
    radial-gradient(circle at center, transparent 40%, rgba(0,0,0,0.1) 100%);

  padding: 35px 30px;
  border-radius: 4px;

  /* Тень стала глубже */
  box-shadow:
    0 2px 5px rgba(0,0,0,0.2),
    0 15px 40px rgba(0,0,0,0.6),
    inset 0 0 80px rgba(139, 69, 19, 0.1); /* Эффект старой бумаги внутри */

  transform: rotate(-1.5deg);
  font-family: 'Courier New', Courier, monospace;
  position: relative;
  text-align: left; /* Выравнивание влево, как в документе */
  color: #222;
  overflow: hidden; /* Чтобы водяной знак не вылезал */
}

/* Водяной знак на фоне (для заполнения пустоты) */
.cs-watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  font-size: 80px;
  font-weight: 900;
  color: rgba(0,0,0,0.04); /* Очень бледный */
  text-transform: uppercase;
  pointer-events: none;
  white-space: nowrap;
  z-index: 0;
  border: 5px solid rgba(0,0,0,0.04);
  padding: 10px 40px;
}

/* Скрепка (улучшенная) */
.cs-report-card::before {
  content: '';
  position: absolute;
  top: -12px; left: 50%; transform: translateX(-50%);
  width: 14px; height: 45px;
  background: linear-gradient(90deg, #bbb, #ddd, #bbb);
  border-radius: 20px;
  box-shadow: 1px 2px 3px rgba(0,0,0,0.4);
  z-index: 10;
}

/* Заголовок */
.cs-report-header {
  border-bottom: 3px solid #333; /* Жирнее линия */
  margin-bottom: 25px;
  padding-bottom: 12px;
  text-align: center;
  position: relative;
  z-index: 2;
}

.cs-report-title {
  font-size: 24px; /* Крупнее */
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #1a1a1a;
  text-shadow: 0 1px 0 rgba(255,255,255,0.5);
}

/* Сетка статистики */
.cs-stats-grid {
  display: flex;
  flex-direction: column;
  gap: 18px; /* Больше воздуха между строками */
  margin-bottom: 35px;
  position: relative;
  z-index: 2;
}

.cs-stat-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline; /* Выравнивание по базовой линии шрифта */
  border-bottom: 1px solid rgba(0,0,0,0.15); /* Тонкая линия-разделитель */
  padding-bottom: 6px;
}

.cs-stat-label {
  font-size: 13px;
  font-weight: 700;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.cs-stat-value {
  font-size: 22px; /* Значительно крупнее */
  font-weight: 900;
  color: #111;
  font-family: 'Courier New', monospace;
  letter-spacing: -1px; /* Чуть плотнее цифры */
}

/* Цвета значений */
.cs-stat-value.bad { color: #c0392b; }
.cs-stat-value.good { color: #27ae60; }
.cs-stat-value.rank-text {
  font-size: 18px; /* Текст ранга чуть меньше цифр, чтобы влез */
  color: #2c3e50;
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-decoration-color: rgba(44, 62, 80, 0.2);
}

/* Штамп "ДЕЛО ЗАКРЫТО" */
.cs-stamp {
  position: absolute;
  bottom: 80px;
  right: 20px;

  border: 4px solid #c0392b; /* Рамка */
  color: #c0392b;
  font-size: 26px;
  font-weight: 900;
  padding: 5px 12px;
  text-transform: uppercase;

  transform: rotate(-15deg) scale(3); /* Стартуем с большого */
  opacity: 0;

  /* Смешивание слоев, чтобы штамп выглядел как чернила на бумаге */
  mix-blend-mode: multiply;

  animation: stampCrash 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) 0.6s forwards;
  z-index: 5;
  pointer-events: none;
}

@keyframes stampCrash {
  to { opacity: 0.85; transform: rotate(-15deg) scale(1); }
}

/* Кнопка "Подшить" */
.cs-close-btn {
  background: #222;
  color: #f0e6cf; /* Цвет бумаги */
  border: none;
  padding: 15px 0;
  width: 100%;

  font-family: inherit;
  font-weight: 900;
  font-size: 18px;
  text-transform: uppercase;
  letter-spacing: 1px;

  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 0 #000;
  margin-top: 10px;
  position: relative;
  z-index: 10;
}

.cs-close-btn:active {
  transform: translateY(4px);
  box-shadow: 0 0 0 #000;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}`, "",{"version":3,"sources":["webpack://./src/components/arcade/games/crimescene/CrimeScene.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,6DAA6D;EAC7D,yBAAyB;EACzB,uEAAuE;EACvE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA,cAAc;AACd;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,qCAAqC;EACrC,qCAAqC;EACrC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,YAAY,eAAe,EAAE,iBAAiB,EAAE;AAChD,YAAY,cAAc,EAAE,gBAAgB,EAAE;AAC9C,cAAc,cAAc,EAAE,gBAAgB,EAAE;;AAEhD,UAAU;AACV;EACE,aAAa;EACb,kDAAkD;EAClD,gCAAgC;EAChC,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;;;;GAIC;EACD,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;EACE,KAAK,UAAU,EAAE,mBAAmB,EAAE;EACtC,OAAO,UAAU,EAAE,qBAAqB,EAAE;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,yDAAyD;EACzD,4BAA4B;EAC5B,kBAAkB;EAClB,qCAAqC;EACrC,sBAAsB,EAAE,wBAAwB;AAClD;;AAEA,mBAAmB,0BAA0B,EAAE;AAC/C,yBAAyB,0BAA0B,EAAE,4BAA4B,EAAE;;AAEnF,mBAAmB;AACnB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yEAAyE;EACzE,2BAA2B;EAC3B,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,+FAA+F;EAC/F,UAAU,EAAE,mCAAmC;AACjD;AACA;EACE,YAAY;EACZ,iBAAiB,EAAE,oCAAoC;EACvD,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,0CAA0C;EAC1C,cAAc;EACd,UAAU;EACV,yBAAyB;EACzB,YAAY,EAAE,sBAAsB;EACpC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2BAA2B;;EAE3B,UAAU;EACV,WAAW;;EAEX,oCAAoC;EACpC,WAAW;;;EAGX,qCAAqC;;EAErC,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA,sDAAsD;AACtD;EACE,WAAW,wCAAwC,EAAE;EACrD,MAAM,yDAAyD,EAAE;EACjE,MAAM,uDAAuD,EAAE;EAC/D,MAAM,yDAAyD,EAAE;EACjE,MAAM,uDAAuD,EAAE;AACjE;;AAEA;EACE,0BAA0B;EAC1B,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA,0FAA0F;AAC1F;EACE,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,QAAQ,EAAE,SAAS,EAAE,gCAAgC;EACrD,cAAc,EAAE,eAAe,EAAE,gBAAgB;EACjD,2BAA2B,EAAE,YAAY;EACzC,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,KAAK,UAAU,EAAE,2CAA2C,EAAE;EAC9D,OAAO,UAAU,EAAE,4CAA4C,EAAE;AACnE;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,6BAA6B,EAAE,oBAAoB,EAAE,qBAAqB;EAC1E,mCAAmC,EAAE,qBAAqB,EAAE,2BAA2B,EAAE,oBAAoB;AAC/G;;AAEA,sDAAsD;;AAEtD;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,8BAA8B,EAAE,sBAAsB;EACtD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,gBAAgB,EAAE,cAAc;;EAEhC,gCAAgC;EAChC,yBAAyB;;EAEzB,uEAAuE;EACvE;4EAC0E;;EAE1E,kBAAkB;EAClB,kBAAkB;;EAElB,sBAAsB;EACtB;;;yCAGuC,EAAE,gCAAgC;;EAEzE,0BAA0B;EAC1B,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB,EAAE,wCAAwC;EAC1D,WAAW;EACX,gBAAgB,EAAE,kCAAkC;AACtD;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,uBAAuB,EAAE,kBAAkB;EAC3C,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU,EAAE,SAAS,EAAE,2BAA2B;EAClD,WAAW,EAAE,YAAY;EACzB,oDAAoD;EACpD,mBAAmB;EACnB,uCAAuC;EACvC,WAAW;AACb;;AAEA,cAAc;AACd;EACE,6BAA6B,EAAE,iBAAiB;EAChD,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe,EAAE,YAAY;EAC7B,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,0CAA0C;AAC5C;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,kCAAkC;EAC7C,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB,EAAE,yCAAyC;EAChE,yCAAyC,EAAE,6BAA6B;EACxE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe,EAAE,wBAAwB;EACzC,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,oBAAoB,EAAE,uBAAuB;AAC/C;;AAEA,mBAAmB;AACnB,qBAAqB,cAAc,EAAE;AACrC,sBAAsB,cAAc,EAAE;AACtC;EACE,eAAe,EAAE,6CAA6C;EAC9D,cAAc;EACd,0BAA0B;EAC1B,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;;EAEX,yBAAyB,EAAE,UAAU;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;;EAEzB,kCAAkC,EAAE,wBAAwB;EAC5D,UAAU;;EAEV,iEAAiE;EACjE,wBAAwB;;EAExB,gFAAgF;EAChF,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,KAAK,aAAa,EAAE,kCAAkC,EAAE;AAC1D;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,cAAc,EAAE,gBAAgB;EAChC,YAAY;EACZ,eAAe;EACf,WAAW;;EAEX,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;;EAEnB,eAAe;EACf,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB","sourcesContent":["/* games/crimescene/CrimeScene.css */\n\n.crimescene-board {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 95%;\n  max-width: 400px;\n  max-height: 95%;\n  background: radial-gradient(circle, #3e3e3e 0%, #1a1a1a 100%);\n  border: 8px solid #5d4037;\n  box-shadow: inset 0 0 40px rgba(0,0,0,0.8), 0 20px 50px rgba(0,0,0,0.9);\n  border-radius: 4px;\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  z-index: 6000;\n}\n\n/* ЗАГОЛОВОК */\n.crimescene-header {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n  background: #fdf6e3;\n  padding: 8px 12px;\n  border-radius: 2px;\n  transform: rotate(-1deg);\n  box-shadow: 0 2px 4px rgba(0,0,0,0.3);\n  font-family: 'Courier New', monospace;\n  color: #2c3e50;\n  box-sizing: border-box;\n}\n\n.cs-title {\n  font-weight: 900;\n  font-size: 18px;\n  text-transform: uppercase;\n  border-bottom: 2px solid #c0392b;\n}\n\n.cs-stats { font-size: 14px; font-weight: bold; }\n.cs-score { color: #27ae60; margin-left: 5px; }\n.cs-penalty { color: #c0392b; margin-left: 5px; }\n\n/* СЕТКА */\n.cs-grid {\n  display: grid;\n  /* Удаляем grid-template-columns: repeat(4, 1fr) */\n  /* Удаляем aspect-ratio: 1 / 1 */\n  width: 100%;\n  max-height: 80vh;\n  box-sizing: border-box;\n}\n\n/* КАРТОЧКА */\n.cs-card-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  perspective: 1000px;\n  cursor: pointer;\n}\n\n.cs-card-container.solved {\n  /*\n     vanish 0.3s -> время самого исчезновения (быстро)\n     ease-in\n     0.6s -> задержка перед стартом (успеваем посмотреть)\n  */\n  animation: vanish 0.3s ease-in 0.6s forwards;\n  pointer-events: none;\n}\n\n@keyframes vanish {\n  0% { opacity: 1; transform: scale(1); }\n  100% { opacity: 0; transform: scale(0.5); }\n}\n\n.cs-card {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  /* Оптимальная скорость переворота: не мгновенно, но быстро */\n  transition: transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);\n  transform-style: preserve-3d;\n  border-radius: 4px;\n  box-shadow: 0 4px 8px rgba(0,0,0,0.4);\n  will-change: transform; /* Оптимизация рендера */\n}\n\n.cs-card.flipped { transform: rotateY(180deg); }\n.cs-card.solved-visual { transform: rotateY(180deg); box-shadow: 0 0 15px #27ae60; }\n\n/* ЛИЦО И РУБАШКА */\n.cs-card-front, .cs-card-back {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  /* ВАЖНО: скрываем заднюю часть, чтобы не было просветов при перевороте */\n  backface-visibility: hidden;\n  -webkit-backface-visibility: hidden;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n.cs-card-front {\n  background: repeating-linear-gradient(45deg, #4a657e, #4a657e 10px, #587691 10px, #587691 20px);\n  z-index: 2; /* Фронт всегда выше по умолчанию */\n}\n.cs-card-front::after {\n  content: '?';\n  font-size: 1.5rem; /* Используем rem для адаптивности */\n  color: rgba(255,255,255,0.3);\n  font-weight: bold;\n}\n\n.cs-card-back {\n  transform: rotateY(180deg);\n  background: #fff;\n  /* Удаляем фиксированный font-size: 42px */\n  line-height: 1;\n  z-index: 1;\n  /* Декор под фотобумагу */\n  padding: 2px; /* Уменьшаем паддинг */\n  padding-bottom: 6px;\n  background-clip: padding-box;\n}\n\n/* Декор \"Скотч\" */\n.cs-card-container::before {\n  content: '';\n  position: absolute;\n  top: -6%;\n  left: 50%;\n  transform: translateX(-50%);\n\n  width: 45%; \n  height: 14%; \n\n  background: rgba(255, 255, 255, 0.3);\n  z-index: 10;\n\n\n  box-shadow: 0 1px 2px rgba(0,0,0,0.1);\n\n  backdrop-filter: blur(1px);\n  pointer-events: none; \n}\n\n/* Более резкая и частая тряска, сохраняющая поворот */\n@keyframes shake-flipped {\n  0%, 100% { transform: rotateY(180deg) translateX(0); }\n  20% { transform: rotateY(180deg) translateX(-8px) rotate(-5deg); }\n  40% { transform: rotateY(180deg) translateX(8px) rotate(5deg); }\n  60% { transform: rotateY(180deg) translateX(-5px) rotate(-3deg); }\n  80% { transform: rotateY(180deg) translateX(5px) rotate(3deg); }\n}\n\n.cs-card-container.shake .cs-card {\n  /* 0.3s - быстро и резко */\n  animation: shake-flipped 0.3s ease-in-out;\n  box-shadow: 0 0 15px #c0392b;\n}\n\n/* Убедись, что у самого контейнера анимации НЕТ (если осталась с прошлого раза - удали) */\n.cs-card-container.shake {\n  animation: none;\n}\n\n/* ШТРАФ (-1) */\n.penalty-floating {\n  position: absolute;\n  top: 50%; left: 50%; transform: translate(-50%, -50%);\n  color: #c0392b; font-size: 40px; font-weight: 900;\n  text-shadow: 2px 2px 0 #fff; z-index: 100;\n  animation: floatUp 1.2s forwards;\n  pointer-events: none;\n}\n@keyframes floatUp {\n  0% { opacity: 1; transform: translate(-50%, -50%) scale(0.5); }\n  100% { opacity: 0; transform: translate(-50%, -150%) scale(1.5); }\n}\n\n/* ЦЕНТРОВКА РАПОРТА */\n.cs-report-wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.cs-report-wrapper .quiz-container {\n  position: relative !important; top: auto !important; left: auto !important;\n  transform: rotate(-1deg) !important; width: 90% !important; max-width: 320px !important; margin: 0 !important;\n}\n\n/* --- ЭКРАН РЕЗУЛЬТАТОВ: ПОЛИЦЕЙСКОЕ ДОСЬЕ (V2) --- */\n\n.cs-result-overlay {\n  position: absolute;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: rgba(0, 0, 0, 0.9); /* Темнее фон вокруг */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 50;\n  backdrop-filter: blur(8px);\n  animation: fadeIn 0.4s ease-out;\n}\n\n.cs-report-card {\n  width: 90%;\n  max-width: 360px; /* Чуть шире */\n\n  /* ЦВЕТ: Папка \"Manila Folder\" */\n  background-color: #f0e6cf;\n\n  /* ТЕКСТУРА: Убрали сетку, добавили шум и виньетку (затемнение краев) */\n  background-image:\n    radial-gradient(circle at center, transparent 40%, rgba(0,0,0,0.1) 100%);\n\n  padding: 35px 30px;\n  border-radius: 4px;\n\n  /* Тень стала глубже */\n  box-shadow:\n    0 2px 5px rgba(0,0,0,0.2),\n    0 15px 40px rgba(0,0,0,0.6),\n    inset 0 0 80px rgba(139, 69, 19, 0.1); /* Эффект старой бумаги внутри */\n\n  transform: rotate(-1.5deg);\n  font-family: 'Courier New', Courier, monospace;\n  position: relative;\n  text-align: left; /* Выравнивание влево, как в документе */\n  color: #222;\n  overflow: hidden; /* Чтобы водяной знак не вылезал */\n}\n\n/* Водяной знак на фоне (для заполнения пустоты) */\n.cs-watermark {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) rotate(-45deg);\n  font-size: 80px;\n  font-weight: 900;\n  color: rgba(0,0,0,0.04); /* Очень бледный */\n  text-transform: uppercase;\n  pointer-events: none;\n  white-space: nowrap;\n  z-index: 0;\n  border: 5px solid rgba(0,0,0,0.04);\n  padding: 10px 40px;\n}\n\n/* Скрепка (улучшенная) */\n.cs-report-card::before {\n  content: '';\n  position: absolute;\n  top: -12px; left: 50%; transform: translateX(-50%);\n  width: 14px; height: 45px;\n  background: linear-gradient(90deg, #bbb, #ddd, #bbb);\n  border-radius: 20px;\n  box-shadow: 1px 2px 3px rgba(0,0,0,0.4);\n  z-index: 10;\n}\n\n/* Заголовок */\n.cs-report-header {\n  border-bottom: 3px solid #333; /* Жирнее линия */\n  margin-bottom: 25px;\n  padding-bottom: 12px;\n  text-align: center;\n  position: relative;\n  z-index: 2;\n}\n\n.cs-report-title {\n  font-size: 24px; /* Крупнее */\n  font-weight: 900;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  color: #1a1a1a;\n  text-shadow: 0 1px 0 rgba(255,255,255,0.5);\n}\n\n/* Сетка статистики */\n.cs-stats-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 18px; /* Больше воздуха между строками */\n  margin-bottom: 35px;\n  position: relative;\n  z-index: 2;\n}\n\n.cs-stat-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline; /* Выравнивание по базовой линии шрифта */\n  border-bottom: 1px solid rgba(0,0,0,0.15); /* Тонкая линия-разделитель */\n  padding-bottom: 6px;\n}\n\n.cs-stat-label {\n  font-size: 13px;\n  font-weight: 700;\n  color: #666;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.cs-stat-value {\n  font-size: 22px; /* Значительно крупнее */\n  font-weight: 900;\n  color: #111;\n  font-family: 'Courier New', monospace;\n  letter-spacing: -1px; /* Чуть плотнее цифры */\n}\n\n/* Цвета значений */\n.cs-stat-value.bad { color: #c0392b; }\n.cs-stat-value.good { color: #27ae60; }\n.cs-stat-value.rank-text {\n  font-size: 18px; /* Текст ранга чуть меньше цифр, чтобы влез */\n  color: #2c3e50;\n  text-decoration: underline;\n  text-decoration-thickness: 2px;\n  text-decoration-color: rgba(44, 62, 80, 0.2);\n}\n\n/* Штамп \"ДЕЛО ЗАКРЫТО\" */\n.cs-stamp {\n  position: absolute;\n  bottom: 80px;\n  right: 20px;\n\n  border: 4px solid #c0392b; /* Рамка */\n  color: #c0392b;\n  font-size: 26px;\n  font-weight: 900;\n  padding: 5px 12px;\n  text-transform: uppercase;\n\n  transform: rotate(-15deg) scale(3); /* Стартуем с большого */\n  opacity: 0;\n\n  /* Смешивание слоев, чтобы штамп выглядел как чернила на бумаге */\n  mix-blend-mode: multiply;\n\n  animation: stampCrash 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) 0.6s forwards;\n  z-index: 5;\n  pointer-events: none;\n}\n\n@keyframes stampCrash {\n  to { opacity: 0.85; transform: rotate(-15deg) scale(1); }\n}\n\n/* Кнопка \"Подшить\" */\n.cs-close-btn {\n  background: #222;\n  color: #f0e6cf; /* Цвет бумаги */\n  border: none;\n  padding: 15px 0;\n  width: 100%;\n\n  font-family: inherit;\n  font-weight: 900;\n  font-size: 18px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 4px 0 #000;\n  margin-top: 10px;\n  position: relative;\n  z-index: 10;\n}\n\n.cs-close-btn:active {\n  transform: translateY(4px);\n  box-shadow: 0 0 0 #000;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
